class ServiceActionValue {
  constructor(serviceAction, field, value) {
    this.serviceAction = serviceAction;
    this.field = field;
    this.value = value;
  }
}

export { ServiceActionValue };
